import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition } from './../../../../wayfinder'
/**
* @see \App\Http\Controllers\Admin\SystemEventController::index
* @see app/Http/Controllers/Admin/SystemEventController.php:28
* @route '/admin/system/events'
*/
export const index = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(options),
    method: 'get',
})

index.definition = {
    methods: ["get","head"],
    url: '/admin/system/events',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Admin\SystemEventController::index
* @see app/Http/Controllers/Admin/SystemEventController.php:28
* @route '/admin/system/events'
*/
index.url = (options?: RouteQueryOptions) => {
    return index.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\SystemEventController::index
* @see app/Http/Controllers/Admin/SystemEventController.php:28
* @route '/admin/system/events'
*/
index.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\SystemEventController::index
* @see app/Http/Controllers/Admin/SystemEventController.php:28
* @route '/admin/system/events'
*/
index.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: index.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Admin\SystemEventController::index
* @see app/Http/Controllers/Admin/SystemEventController.php:28
* @route '/admin/system/events'
*/
const indexForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\SystemEventController::index
* @see app/Http/Controllers/Admin/SystemEventController.php:28
* @route '/admin/system/events'
*/
indexForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\SystemEventController::index
* @see app/Http/Controllers/Admin/SystemEventController.php:28
* @route '/admin/system/events'
*/
indexForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

index.form = indexForm

/**
* @see \App\Http\Controllers\Admin\SystemEventController::retry
* @see app/Http/Controllers/Admin/SystemEventController.php:53
* @route '/admin/system/events/retry'
*/
export const retry = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: retry.url(options),
    method: 'post',
})

retry.definition = {
    methods: ["post"],
    url: '/admin/system/events/retry',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Admin\SystemEventController::retry
* @see app/Http/Controllers/Admin/SystemEventController.php:53
* @route '/admin/system/events/retry'
*/
retry.url = (options?: RouteQueryOptions) => {
    return retry.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\SystemEventController::retry
* @see app/Http/Controllers/Admin/SystemEventController.php:53
* @route '/admin/system/events/retry'
*/
retry.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: retry.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\SystemEventController::retry
* @see app/Http/Controllers/Admin/SystemEventController.php:53
* @route '/admin/system/events/retry'
*/
const retryForm = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: retry.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\SystemEventController::retry
* @see app/Http/Controllers/Admin/SystemEventController.php:53
* @route '/admin/system/events/retry'
*/
retryForm.post = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: retry.url(options),
    method: 'post',
})

retry.form = retryForm

const events = {
    index: Object.assign(index, index),
    retry: Object.assign(retry, retry),
}

export default events